module.exports = ["用户给客服发送默认消息"]


//////////////////
// WEBPACK FOOTER
// ./src/config/noShowMessage.json
// module id = McQi
// module chunks = 2